const SENSITIVE_CONFIG_KEY =
    /password|secret|credential|api[_-]?key|private|token/i;

/** 仅允许 http(s) 外链，阻断 javascript:、data: 等协议 */
export function isSafeHttpUrl(url) {
    if (!url || typeof url !== 'string') return false;
    try {
        const parsed = new URL(url.trim());
        return parsed.protocol === 'http:' || parsed.protocol === 'https:';
    } catch {
        return false;
    }
}

/** 系统配置键名疑似敏感时，列表展示脱敏 */
export function isSensitiveConfigKey(configKey) {
    return SENSITIVE_CONFIG_KEY.test(String(configKey || ''));
}

export function maskSensitiveValue(value) {
    if (value == null || value === '') return value;
    return '••••••';
}
